import { Stack, VStack } from "@chakra-ui/react";
import React from "react";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import { useSelector } from "react-redux";

const Layout = React.memo(() => {
  const { background_img } = useSelector((state) => state.other);

  return (
    <VStack
      h={"100vh"}
      maxW={"full"}
      spacing={0}
    >
      <Stack
        h={["16","16","24"]}
        position={"sticky"}
        bg={"#727b82"}
        w={"full"}
        justify={"center"}
      >
        <Header />
      </Stack>
      <Stack
        overflowY={"auto"}
        w={"full"}
        h={"full"}
        maxW={"full"}
        display={"flex"}
        flexDirection={"column"}
        justifyContent={"space-between"}
        style={{"--bgimg" : `url(${background_img})`}}
        className="home_bg"
      >
        <Outlet />
        <Footer />
      </Stack>
    </VStack>
  );
});

export default Layout;
